import React from 'react';
import Icon from './Icon';
import './EmptyState.css';

const EmptyState = ({ icon, title, description, actionLabel, onAction }) => (
  <div className="empty-state">
    {icon && <Icon name={icon} className="empty-state-icon" />}
    {title && <h3 className="empty-state-title">{title}</h3>}
    {description && <p className="empty-state-description">{description}</p>}
    {actionLabel && onAction && (
      <button type="button" className="btn btn-primary empty-state-action" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
